var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.58 0 0 3.58 0 8C0 11.54 2.29 14.63 5.47 15.84C5.88 15.91 6.04 15.68 6.04 15.49C6.04 15.32 6.03 14.88 6.03 14.38C4 14.88 3.48 13.73 3.48 13.73C3.13 12.92 2.62 12.69 2.62 12.69C1.87 12.24 2.67 12.26 2.67 12.26C3.49 12.31 3.92 13.11 3.92 13.11C4.65 14.36 5.91 14.02 6.37 13.81C6.44 13.26 6.67 12.89 6.92 12.69C5.04 12.49 3.06 11.75 3.06 8.38C3.06 7.42 3.39 6.67 3.94 6.07C3.86 5.86 3.56 4.94 4.04 3.71C4.04 3.71 4.74 3.48 6.04 4.58C6.73 4.39 7.47 4.29 8.21 4.29C8.95 4.29 9.69 4.39 10.38 4.58C11.68 3.48 12.38 3.71 12.38 3.71C12.86 4.94 12.56 5.86 12.48 6.07C13.03 6.67 13.36 7.42 13.36 8.38C13.36 11.76 11.38 12.48 9.5 12.69C9.8 12.91 10.06 13.36 10.06 14.05C10.06 15.02 10.05 15.86 10.05 15.49C10.05 15.68 10.21 15.91 10.62 15.84C13.81 14.63 16.1 11.54 16.1 8C16.1 3.58 12.42 0 8 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon2);
export default __webpack_public_path__ + "static/media/nav-icon2.2067edd578f146015dc87ccd54a5e688.svg";
export { ForwardRef as ReactComponent };